import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-error-banner',
  templateUrl: './error-banner.component.html',
  styleUrls: ['./error-banner.component.scss'],
  standalone: true
})
export class ErrorBannerComponent {
  @Input() message: string = 'An unexpected error occurred.';
  //@Input() description: string = '';
}
